import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";
import { SectionHeading } from "./Primitives";

export const FAQs = () => (
  <section className="bg-white py-16 sm:py-28 scroll-mt-20 rule" id="faqs" data-testid="faqs-section">
    <div className="container-x grid lg:grid-cols-12 gap-10 lg:gap-16">
      <div className="lg:col-span-4"><SectionHeading eyebrow="FAQs" title="Questions, answered plainly." testId="faqs-heading" /></div>
      <div className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-divider">
              <AccordionTrigger className="py-5 text-left text-base sm:text-lg font-medium text-ink hover:no-underline [&>svg]:text-ink" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="pb-6 text-[15px] leading-relaxed text-ink max-w-2xl" data-testid={`faq-content-${i}`}>{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
